import { InjectionToken } from '@angular/core';

type RuntimeWindow = Window & {
  __conductorAuth?: {
    enableAuthentication?: unknown;
  };
  __env?: {
    AUTH_ENABLE_AUTHENTICATION?: unknown;
  };
};

function parseBoolean(value: unknown): boolean | undefined {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1' || normalized === 'yes') {
      return true;
    }
    if (normalized === 'false' || normalized === '0' || normalized === 'no') {
      return false;
    }
  }

  if (typeof value === 'number') {
    if (value === 1) {
      return true;
    }
    if (value === 0) {
      return false;
    }
  }

  return undefined;
}

function resolveAuthenticationEnabledTokenDefault(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  const runtimeWindow = window as RuntimeWindow;
  const sharedValue = parseBoolean(runtimeWindow.__conductorAuth?.enableAuthentication);
  if (sharedValue !== undefined) {
    return sharedValue;
  }

  const envValue = parseBoolean(runtimeWindow.__env?.AUTH_ENABLE_AUTHENTICATION);
  if (envValue !== undefined) {
    return envValue;
  }

  return true;
}

export const AUTHENTICATION_ENABLED = new InjectionToken<boolean>('AUTHENTICATION_ENABLED', {
  providedIn: 'root',
  factory: () => resolveAuthenticationEnabledTokenDefault(),
});

// Backward-compatible token kept to avoid runtime DI failures from stale/cached bundles.
export const AUTHORIZATION_ENABLED = new InjectionToken<boolean>('AUTHORIZATION_ENABLED', {
  providedIn: 'root',
  factory: () => false,
});

export const AUTH_SHELL_APP_URL = new InjectionToken<string>('AUTH_SHELL_APP_URL', {
  providedIn: 'root',
  factory: () => '',
});
